import { useEffect, useCallback } from 'react'

export interface KeyboardNavigationOptions {
  onNext?: () => void
  onPrevious?: () => void
  enableNext?: boolean
  enablePrevious?: boolean
  enabled?: boolean
}

export const useKeyboardNavigation = ({ onNext, onPrevious, enableNext = true, enablePrevious = true, enabled = true }: KeyboardNavigationOptions): void => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      // A control that handles arrows itself (segmented control, menu) has already used the key.
      if (!enabled || event.defaultPrevented) {
        return
      }

      const target = event.target as HTMLElement
      const isInputElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable

      if (isInputElement) {
        return
      }

      if (event.key === 'ArrowRight' && enableNext && onNext) {
        event.preventDefault()
        onNext()
      } else if (event.key === 'ArrowLeft' && enablePrevious && onPrevious) {
        event.preventDefault()
        onPrevious()
      }
    },
    [enabled, enableNext, enablePrevious, onNext, onPrevious],
  )

  useEffect(() => {
    if (!enabled) {
      return
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [enabled, handleKeyDown])
}
